<template>
  <div
    class="t"
    :style="{'background-image': `url('https://source.unsplash.com/1600x900/?agriculture')`}"
  >
    <form novalidate class="md-layout" @submit.prevent="validateUser" style="border-radius: 30px;">
      <CContainer>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard class="p-4">
                <CCardBody>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <md-card-content>
                    <md-field :class="getValidationClass('email')">
                      <label for="email">Email</label>
                      <md-input
                        type="email"
                        name="email"
                        id="email"
                        autocomplete="email"
                        v-model="form.email"
                        :disabled="sending"
                      />
                      <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
                      <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
                    </md-field>
                  </md-card-content>
                  <md-card-content>
                    <md-field :class="getValidationClass('password')">
                      <label>Password</label>
                      <md-input
                        type="password"
                        name="password"
                        id="password"
                        autocomplete="password"
                        v-model="form.password"
                      />
                      <span
                        class="md-error"
                        v-if="!$v.form.password.required"
                      >The Password is required</span>
                    </md-field>
                  </md-card-content>
                  <span class="text-danger">{{err}}</span>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <md-button type="submit" class="md-success" @click="signin()">Sign in</md-button>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <span class="text-danger">{{err}}</span>
        <!--               <CButton color="link" class="px-0">Forgot password?</CButton>

                     <CButton color="link" class="px-0" >Register now!</CButton> 
 -->
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
              <CCard
                color="white"
                text-color="white"
                class="text-center py-12 d-sm-down-none"
                style=" justify-content: center;"
                body-wrapper
              >
                <img
                  :src="imgLogo"
                  alt
                  width="400"
                  height="400"
                  style=" justify-content: center; margin-top:20px;"
                />
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </form>
    <div></div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import User from "@/services/Users";
import router from "@/routes";
export default {
  name: "FormValidation",
  mixins: [validationMixin],
  props: {
    title: {
      type: String,
      default: "Vue MD"
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg")
    },
    imgLogo: {
      type: String,
      default: require("@/assets/img/logo_.png")
    },
    sidebarItemColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    num: 1,
    form: {
      password: null,
      firstName: null,
      lastName: null,
      gender: null,
      age: null,
      email: null
    },
    err: "",
    userSaved: false,
    sending: false,
    lastemail: null
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3)
      },
      lastName: {
        required,
        minLength: minLength(3)
      },
      age: {
        required,
        maxLength: maxLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    saveUser() {
      this.sending = true;

      // Instead of this timeout, here you can call your API
      window.setTimeout(() => {
        this.lastUser = `${this.form.firstName} ${this.form.lastName}`;
        this.userSaved = true;
        this.sending = false;
        this.clearForm();
      }, 1500);
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
    signin() {
      if (this.form.email.length >= 6 && this.form.password.length > 0) {
        User.login(this.form.email, this.form.password)
          .then(success => {

            this.$store.commit("dkhlat");

            router.push("/");
            
            // window.location.href = "http://localhost:8080/"
          })
          .catch(er => {
            this.err = er;
            console.log(er);
          });
      }
    }
  },
  created() {
    if (this.$store.state.Auth === true) router.push("/");
  },
  mounted() {
    console.log(this.image);
    let totalCount = 6;
    this.num = Math.ceil(Math.random() * totalCount);
  }
};
</script>

<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.test {
  width: 490px;
  height: 360px;
  // display: flex ;
  // justify-content: center;
  // height: 200px;
  // align-items: center;
}
.t {
  width: 100%;
  height: 100%;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  // background-image: url("../../assets/img/3.jpg");
  // position: absolute;
  display: grid;
  justify-content: center;

  align-items: center;
  align-content: center;
  // box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
}
</style>
